export const DATA_INVALIDATION_EVENT = 'tradapp-data-invalidated';

export const JOURNAL_DEPENDENT_RESOURCES = Object.freeze([
  'journal',
  'performance',
  'statistics',
  'guardian',
  'accounts',
]);

export const dispatchDataInvalidation = ({ accountId, resources = JOURNAL_DEPENDENT_RESOURCES, journalEntryId = null, datasetVersion = null, reason = 'mutation' } = {}) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent(DATA_INVALIDATION_EVENT, {
      detail: {
        accountId: accountId == null ? null : String(accountId),
        resources: Array.from(new Set(resources)),
        journalEntryId: journalEntryId == null ? null : String(journalEntryId),
        datasetVersion,
        reason,
      },
    })
  );
};

export const invalidationMatches = (event, accountId, resource) => {
  const detail = event?.detail || {};
  const resources = Array.isArray(detail.resources) ? detail.resources : [];
  const sameScope = detail.accountId == null || String(detail.accountId) === String(accountId);
  return sameScope && resources.includes(resource);
};

